
    import QuestionMixin from '@/components/JobView/Apply/Questions/QuestionMixin';
    import C1Tags from '@/C1Components/C1Tags';

    export default {
        name: 'QuestionMultiselect',

        components: {
            C1Tags,
        },

        mixins: [QuestionMixin],

        data() {
            return {
                answer: [],
                questionId: `question_multiselect_${this.question.id}`,
            };
        },

        watch: {
            answer() {
                this.$emit('answer', {
                    question: this.question,
                    answer: this.answer.map(o => o.id),
                });
            },
        },

        created() {
            this.getArrayAnswer();
        },

        methods: {},
    };
